<h2 mat-dialog-title>
  EZLynx Survey
</h2>

<mat-dialog-content>
  <p>Help us improve our products and services by taking our annual survey.</p>
  <p>Your feedback is important to us and helps shape the future of EZLynx.</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button"
          mat-button
          color="primary"
          mat-dialog-close>Close</button>
  <button type="button"
          mat-button
          color="primary"
          (click)="dismissForever()">Don't ask again</button>
  <a [href]="matDialogData"
     target="_blank"
     mat-button
     color="primary"
     (click)="dismissForever()">Take survey</a>
</mat-dialog-actions>